var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown-item',_vm._g({},_vm.$listeners),[_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.icon),expression:"icon"}],attrs:{"name":_vm.icon,"width":"16"}}),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }